import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Popup"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 3H7.5C6.6726 3.00247 6.00247 3.6726 6 4.5V15C6.00247 15.8274 6.6726 16.4975 7.5 16.5H21C21.8274 16.4975 22.4975 15.8274 22.5 15V4.5C22.4975 3.6726 21.8274 3.00247 21 3ZM2.25 20.25V12.75H3.75V11.25H2.25C1.4226 11.2525 0.752471 11.9226 0.75 12.75V20.25C0.752471 21.0774 1.4226 21.7475 2.25 21.75H12.75C13.5774 21.7475 14.2475 21.0774 14.25 20.25V18.75H12.75V20.25H2.25ZM7.5 15H21V4.5H7.5V15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Popup.vue"]]);
